/**
 * General helper methods
 */
export default class Tools {

	/**
	 * @returns True if the site is running in ios
	 */
	public static isios(): boolean{
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		  ].includes(navigator.platform)
		  // iPad on iOS 13 detection
		  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	/**
	 * True if in localhost
	 */
	public static isLocalhost(): boolean {
		return window.location.hostname === 'localhost';
	}

	/**
	 * True if the supplied string is a JSON string
	 * @param str The string to evaluate
	 */
	public static isJSON(str: string): boolean {
		return (str.startsWith('{') && str.endsWith('}')) || 
        ((str.startsWith('[') && str.endsWith(']')));
	}

	/**
	 * Generates a brand new guid
	 */
	public static generateGuid(): string {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	/**
	 * Generates a random integer between a minimum (included) and a maximum (included) number
	 * @param min The minimun to include
	 * @param max The maximum number to include
	 */
	public static  randomInteger(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	  }
	public static randomizeItemsInArray(array: any[]) {
		for (var i = array.length - 1; i > 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	}
}
